var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"display",domProps:{"innerHTML":_vm._s(_vm.returnImage())}})
}
var staticRenderFns = []

export { render, staticRenderFns }